/**
 * Enrollment Wizard Route
 *
 * A guided enrollment experience for parents to enroll their children in classes.
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { EnrollmentWizard } from "@/features/enrollments"

export const Route = createFileRoute("/_layout/enroll")({
  component: EnrollPage,
})

function EnrollPage() {
  const navigate = useNavigate()

  const handleComplete = () => {
    // Navigate to enrollments page with success state
    // TODO: TanStack Router strict route typing requires search params - needs route-specific navigate
    void (navigate as (opts: { to: string }) => Promise<void>)({ to: "/enrollments" })
  }

  const handleCancel = () => {
    // Navigate back to dashboard or enrollments
    void (navigate as (opts: { to: string }) => Promise<void>)({ to: "/" })
  }

  return (
    <EnrollmentWizard onComplete={handleComplete} onCancel={handleCancel} />
  )
}
